import {
  formatBuildInfoLabel,
  shouldShowBuildInfo,
} from '../../../../../packages/shared/src/build-info';

type Tone = 'onDark' | 'onLight';

/**
 * Small top-right build label (version · commit · date).
 * Rendered on the login screen only; hidden when VITE_APP_ENV=production.
 */
export function BuildInfoLabel({ tone = 'onDark' }: { tone?: Tone }) {
  if (!shouldShowBuildInfo(import.meta.env.VITE_APP_ENV)) {
    return null;
  }

  const label = formatBuildInfoLabel(
    import.meta.env.VITE_APP_VERSION,
    import.meta.env.VITE_GIT_COMMIT,
    import.meta.env.VITE_GIT_COMMIT_DATE,
  );

  const color = tone === 'onDark' ? 'text-white/45' : 'text-slate-500';

  return (
    <div
      className={`pointer-events-none fixed top-2 right-3 z-[100] max-w-[min(100vw-1.5rem,28rem)] truncate text-[10px] leading-none font-mono tracking-wide ${color}`}
      title={label}
      data-testid="build-info-label"
    >
      {label}
    </div>
  );
}
